export default __webpack_public_path__ + "static/media/startlater_3@3x.9ca1f38a.jpg";